import { render, staticRenderFns } from "./ActiveModuleSelectbox.vue?vue&type=template&id=2098b02f&"
import script from "./ActiveModuleSelectbox.vue?vue&type=script&lang=js&"
export * from "./ActiveModuleSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports